import { render, staticRenderFns } from "./PlatformIntegration.vue?vue&type=template&id=01c70e0a&scoped=true"
import script from "./PlatformIntegration.vue?vue&type=script&lang=js"
export * from "./PlatformIntegration.vue?vue&type=script&lang=js"
import style0 from "./PlatformIntegration.vue?vue&type=style&index=0&id=01c70e0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c70e0a",
  null
  
)

export default component.exports